import React from 'react';
import { LazyLoader } from '../LazyLoader';
import { isClientSide } from '../../../common/utils';

const MenuEditorContainer = React.lazy(() => import('./MenuEditorContainer'));

interface LazyMenuEditorProps {
  isPreview: boolean;
  setIsPreview: (isPreview: boolean) => void;
}

const LazyMenuEditor = ({ isPreview, setIsPreview }: LazyMenuEditorProps) => {
  return (
    isClientSide() && (
      <LazyLoader
        lazyComponent={MenuEditorContainer}
        isPreview={isPreview}
        setIsPreview={setIsPreview}
      />
    )
  );
};

export { LazyMenuEditor as default };
